// DEPLOY: /var/www/woody.wtf/frontend/src/components/TradingTabs.js
// Tab bar shared by the Trading section pages (Portfolio, and later Trade, Options,
// Orders, Currency). Add each page to TRADING_PAGES as it's built and routed in App.js.
import React from 'react';
import { NavLink } from 'react-router-dom';

export const TRADING_PAGES = [
  { label: 'Portfolio', path: '/trading' },
  { label: 'Trade',     path: '/trading/trade' },
  { label: 'Options',   path: '/trading/options' },
  { label: 'Orders',    path: '/trading/orders' },
  { label: 'Currency',  path: '/trading/fx' },
  { label: 'Movers',    path: '/trading/movers' },
];

export default function TradingTabs() {
  return (
    <div style={{ display: 'flex', gap: '4px', borderBottom: '1px solid var(--border)', marginBottom: '24px' }}>
      {TRADING_PAGES.map(p => (
        <NavLink key={p.path} to={p.path} end
          style={({ isActive }) => ({
            padding: '10px 16px', fontSize: '13px', textDecoration: 'none', marginBottom: '-1px',
            fontWeight: isActive ? 600 : 500,
            color: isActive ? 'var(--accent)' : 'var(--text-muted)',
            borderBottom: `2px solid ${isActive ? 'var(--accent)' : 'transparent'}`,
          })}>
          {p.label}
        </NavLink>
      ))}
    </div>
  );
}
